import React, { useRef, useEffect } from 'react';
import Fields from '../Fields';
import Modal from '@components/Modal';
import useMatchMedia from '@hooks/useMatchMedia';
import * as styles from './MobileInputs.module.scss';

export default React.memo(function MobileInputs({
  state,
  validations,
  canValidate,
  canRefresh,
  visibleErrors,
  cachedZipCodes,
  addCachedZipCode,
  inputsAreOpen,
  setState,
  cancel,
  updateErrors,
  setCanValidate,
  refreshData,
  setCurrentInput,
  prefetchScenario
}) {
  const modal = useRef();
  const scrollTimer = useRef();

  useEffect(() => {
    clearTimeout(scrollTimer.current);

    if (!inputsAreOpen) {
      scrollTimer.current = setTimeout(() => {
        modal.current?.resetScroll();
      }, 300);
    }
  }, [inputsAreOpen, modal]);

  const headline = useMatchMedia(
    '(max-width: 450px) and (min-width: 362px)',
    'Personalize your loan',
    'Personalize your loan details'
  );

  return (
    <Modal
      id="calculator-inputs-modal"
      header={headline}
      closeLabel="Cancel"
      buttonText="Refresh Mortgage Rates"
      ref={modal}
      contentClassName={styles.content}
      buttonIsDisabled={!canRefresh}
      buttonAriaControls="calculator-rate-table"
      onButtonClick={() => {
        if (canRefresh) {
          refreshData();
        } else {
          cancel();
        }
      }}
      isOpen={inputsAreOpen}
      close={cancel}
    >
      <fieldset>
        <Fields
          state={state}
          canRefresh={canRefresh}
          errors={visibleErrors}
          cachedZipCodes={cachedZipCodes}
          addCachedZipCode={addCachedZipCode}
          validations={validations}
          canValidate={canValidate}
          inputsAreOpen={inputsAreOpen}
          updateErrors={updateErrors}
          setCanValidate={setCanValidate}
          setCurrentInput={setCurrentInput}
          onChange={setState}
          refresh={refreshData}
          prefetchScenario={prefetchScenario}
          showInlineErrors
        />
      </fieldset>
    </Modal>
  );
});
